import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import rootIndex from "./store/root_index";
import apiConfig from "./config/api.config";
import * as Sentry from "@sentry/react";

const { store, persistor } = rootIndex;
const { APPLICATION_URL } = apiConfig;

const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED === "true";
console.log("Sentry ENV variable", sentryEnabled);

if (sentryEnabled) {
  Sentry.init({
    environment: process.env.REACT_APP_ENVTYPE,
    dsn: "https://48cf27f55aeed15c5465fda8bd58ebac@sentry-prod.salesdrive.app/10",
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ["localhost", "avivadev-v2.salesdrive.app", "avivauat-v2.salesdrive.app", "athena-preprod.iorta.in", "athena.iorta.in"],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.5, // Adjust this as needed; 50% sample rate
    // Session Replay
    replaysSessionSampleRate: 0.05, // Reduce to 5% sample rate
    replaysOnErrorSampleRate: 1.0, // 100% sample rate for errors
    // Limit breadcrumbs and context data to avoid large payloads
    maxBreadcrumbs: 30, // Reduce the number of breadcrumbs further
    maxValueLength: 500, // Limit the length of values in events

    // Use beforeSend to truncate or remove large data from events
    beforeSend(event) {
      // Truncate or remove large data
      if (event.exception && event.exception.values) {
        event.exception.values = event.exception.values.map((exception) => {
          if (exception.value && exception.value.length > 500) {
            exception.value = exception.value.substring(0, 500) + "... [truncated]";
          }
          return exception;
        });
      }

      // Remove unnecessary or large contexts
      if (event.contexts) {
        delete event.contexts.device; // Remove device context to reduce size
        delete event.contexts.runtime; // Remove runtime context if not needed
      }

      // Truncate request data if necessary
      if (event.request && event.request.url && event.request.url.length > 200) {
        event.request.url = event.request.url.substring(0, 200) + "...";
      }

      return event;
    },

    // Filter breadcrumbs to avoid excessive data
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.message && breadcrumb.message.length > 100) {
        breadcrumb.message = breadcrumb.message.substring(0, 100) + "... [truncated]";
      }
      return breadcrumb;
    },
  });

  // Configure the scope to limit unnecessary data
  Sentry.configureScope((scope) => {
    scope.clear(); // Clear any unnecessary data
    scope.setTag("environment", "production"); // Set only essential data
    scope.setLevel("error"); // Set default level to 'error'
  });
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
